"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.demonstrationsImpressionsList = void 0;
const md_1 = require("react-icons/md");
const gi_1 = require("react-icons/gi");
const React = require("react");
const general_impression_config_1 = require("../config/general-impression.config");
exports.demonstrationsImpressionsList = [
    {
        id: 0,
        title: 'Receita',
        subtitle: 'Crescendo',
        description: 'Ao analisar a empresa, foi verificado que sua capacidade de geração de receita cresce a cada ano que se passa e ela consegue gerenciar o crescimento de receita a longo prazo muito bem.',
        icon: React.createElement(md_1.MdOutlineReceiptLong, { size: general_impression_config_1.impressionConfig.size }),
        iconColor: general_impression_config_1.impressionConfig.colors.nice,
        importantLevel: 90,
        reportableIdentification: 'RECEITA_CRESCENDO',
    },
    {
        id: 1,
        title: 'Receita',
        subtitle: 'Caindo',
        description: 'Ao analisar a empresa, foi verificado que sua capacidade de geração de receita está caindo a cada ano que se passa, tenha cuidado ao manter papeis dela a longo prazo.',
        icon: React.createElement(md_1.MdOutlineReceiptLong, { size: general_impression_config_1.impressionConfig.size }),
        iconColor: general_impression_config_1.impressionConfig.colors.danger,
        importantLevel: 90,
        reportableIdentification: 'RECEITA_CAINDO',
    },
    {
        id: 2,
        title: 'Receita',
        subtitle: 'problemática',
        description: 'Ao analisar a empresa, foi verificado que ela tem alguns problemas em gerar receita a longo prazo, tenha cuidado.',
        icon: React.createElement(md_1.MdOutlineReceiptLong, { size: general_impression_config_1.impressionConfig.size }),
        iconColor: general_impression_config_1.impressionConfig.colors.warning,
        importantLevel: 85,
        reportableIdentification: 'RECEITA_PROBLEMATICA',
    },
    {
        id: 3,
        title: 'Lucros',
        subtitle: 'Aumentando',
        description: 'Ao analisar a empresa, foi possível verificar que ela consegue manter seus lucros líquidos maiores a cada ano que se passa, ótimo.',
        icon: React.createElement(gi_1.GiReceiveMoney, { size: general_impression_config_1.impressionConfig.size }),
        iconColor: general_impression_config_1.impressionConfig.colors.nice,
        importantLevel: 80,
        reportableIdentification: 'LUCROS_AUMENTANDO',
    },
    {
        id: 4,
        title: 'Lucro',
        subtitle: 'Caindo',
        description: 'Ao analisar a empresa, foi possível verificar que os lucros líquidos gerados estão caindo a cada ano que se passa, tenha cuidado.',
        icon: React.createElement(md_1.MdOutlineTrendingDown, { size: general_impression_config_1.impressionConfig.size }),
        iconColor: general_impression_config_1.impressionConfig.colors.danger,
        importantLevel: 80,
        reportableIdentification: 'LUCROS_CAINDO',
    },
    {
        id: 5,
        title: 'Lucro',
        subtitle: 'PROBLEMÁTICO',
        description: 'Ao analisar a empresa, foi identificado que nos últimos tempos seus lucros líquidos estão muito baixos, tenha cuidado.',
        icon: React.createElement(md_1.MdMoneyOff, { size: general_impression_config_1.impressionConfig.size }),
        iconColor: general_impression_config_1.impressionConfig.colors.warning,
        importantLevel: 85,
        reportableIdentification: 'LUCRO_PROBLEMATICO',
    },
];
//# sourceMappingURL=demonstrations.impressions.js.map